export enum WarehouseSkuUsageStatus {
  New = 'NEW',
  OccurringInGood = 'OCCURRING_IN_GOOD',
  OccurringInReceipts = 'OCCURRING_IN_RECEIPTS',
}
